import React, { useState, useEffect } from "react";
import {
  Box,
  Menu,
  MenuItem,
  PaginationItem,
  Alert,
  Snackbar,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AssignmentIcon from "@mui/icons-material/Assignment";
import AddConsumptionByEquipment from "./AddConsumptionByEquipment";
import ViewConsumptionByEquipment from "./ViewConsumptionByEquipment";
import FilterDrawer from "../../../../Components/Masters/FilterDrawer";
import { get, api, del } from "../../../../utils/api";
import { companyId } from "../../../../utils/companyId";
import DateRangePickerComponent from "../../../Masters/Roles and Permissions/Filters/Date";
import MultiSelect from "../../../Masters/Roles and Permissions/Filters/MultiSelect";
import Range from "../../../Masters/Roles and Permissions/Filters/Range";
import { styled } from "@mui/material/styles";
import Cards from "../../../../Components/Common/Cards";
import ViewTable from "../../../../Components/Common/ViewTable";
import DeleteDialog from "../../../../Components/Masters/DeleteDialog";
import PaginationBox from "../../../../Components/Masters/Pagination";
import MonthYearFilter from "../../../Masters/Roles and Permissions/Filters/MonthYearFilter";
import BulkUploadModal from "../../../../Components/Common/BulkUploadModal";
import TopMenuUpload from "../../../../Components/Masters/TopMenuUpload";
import { formatNumber } from "../../../../utils/formatNumber";
import { formatNumberCommaSeparated } from "../../../../utils/common";
import BulkUpload from "../../BulkUploadEquipment";
import { useUser } from "../../../../context/AuthContext";
import DeleteAlertDialog from "../../../../Components/Masters/DeleteAlertDialog";
import {
  mapTableDataWithFacility,
  shouldShowFacilityColumn,
  withFacilityViewTableHeader,
} from "../../../../utils/facilityColumn";

const ElectricityConsumption = () => {
  const { user } = useUser();
  const showFacilityColumn = shouldShowFacilityColumn(user);
  const [petroleums, setPetroleums] = useState([]);
  const [sortConfig, setSortConfig] = useState({
    key: "createdAt",
    direction: "desc",
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [addData, setAddData] = useState(false);
  const [uniqueValues, setUniqueValues] = useState({});
  const [selectedFields, setSelectedFields] = useState({
    equipment: [],
  });
  const [appliedFilters, setAppliedFilters] = useState({
    date: false,
    consumptionPeriod: false,
    equipment: false,
    quantityConsumed: false,
    hoursUsed: false,
  });
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);
  const [view, setView] = useState(false);
  const [dataView, setdataView] = useState(null);
  const [dataforView, setdataForView] = useState(null);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [tableData, setTableData] = useState([]);
  // const [limit] = useState(10); // Number of items per page
  const [selectedFilter, setSelectedFilter] = useState("Date");
  const [drawerFilterOpen, setDrawerFilterOpen] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [formData, setFormData] = useState({});
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [filterValues, setFilterValue] = useState([]);
  const [errors, setErrors] = useState({
    Date: false,
    equipment: false,
    quantityConsumed: false,
    hoursUsed: false,
  });
  const [hoursRange, setHoursRange] = useState({ min: "", max: "" });
  const [cardData, setCardData] = useState({});
  const [filter, setFilters] = useState({});
  const [startMonth, setStartMonth] = useState(null);
  const [endMonth, setEndMonth] = useState(null);
  const [unitConsumption, setUnitOfConsumption] = useState({
    min: "",
    max: "",
  });
  const [selectedEquipment, setSelectedEquipment] = useState("");
  const [bulkUploadModal, setBulkUploadModal] = useState(false);
  const [excelData, setExcelData] = useState(null);

  const [tempFilter, setTempFilter] = useState({
    startDate: null,
    endDate: null,
    startMonth: null,
    endMonth: null,
    equipment: [],
    unitConsumption: { min: "", max: "" },
  });
  const [bulkUploadTable, setBulkUploadTable] = useState(true);
  const [formDataBulkUpload, setFormDataBulkUpload] = useState({});
  const [matchData, setMatchData] = useState([]);
  const [equipmentData, setEquipmentData] = useState([]);
  const uploadErrorClose = () => {
    setBulkUploadTable(true);
  };

  const fetchExcelData = async () => {
    await get("/scope2/consumptionByEquipment/electricity/equipment")
      .then((res) => {
        let data = res.data.data;
        let arr = data.map((el, idx) => {
          return {
            "Month (in 01/25 or Jan-25)": "",
            Equipment: el?.equipment,
            "Hours Used": "",
            "Remark (optional)": "",
          };
        });
        setExcelData(arr);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleCloseBulkUpload = () => {
    setBulkUploadModal(false);
    fetchData();
  };
  const equipmentList = async () => {
    const response = await get(`/master/Electricity/getEquipment`);
    console.log(response.data.data, " equipmentList");
    setEquipmentData(response.data.data.map((item) => item.equipment));
    return response.data.data.map((item) => item.equipment);
  };
  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        const [equipment] = await Promise.all([equipmentList()]);

        console.log(equipment, "Final Equipment List");

        // Optionally store them in state

        // Now fetch your excel data
        fetchExcelData();
      } catch (error) {
        console.error("Error fetching equipment or vendors:", error);
      }
    };
    fetchInitialData();
  }, []);

  let bannerData = [
    {
      title: "Total Electricity Consumed",
      description: cardData.totalSum ? formatNumber(cardData.totalSum) : 0,
      unit: "KWH",
    },
    {
      title: "Top Energy Consuming Equipments",
      description: cardData.topEquipment || "N/A",
    },
    {
      title: "Avg. Usage Hours per Equipment",
      description: cardData.avgUsageHours
        ? formatNumberCommaSeparated(formatNumber(cardData.avgUsageHours))
        : 0,
      // unit: "KWH",
      filter: "option",
      filterTitle: "Tap to Select",
      key: "equipment",
      filterValues: filterValues,
      defaultValue: selectedEquipment || filterValues[0],
    },
  ];

  const headers = withFacilityViewTableHeader([
    { key: "createdAt", label: "Date", sortable: true, width: "12%" },
    {
      key: "consumptionPeriod",
      label: "Consumption Month",
      sortable: true,
      width: showFacilityColumn ? "16%" : "15%",
    },
    { key: "equipment", label: "Equipment", sortable: true, width: "12%" },
    { key: "brand", label: "Brand", sortable: true, width: "12%" },
    {
      key: "model",
      label: "Model",
      sortable: true,
      width: "12%",
    },
    // {
    //   key: "usedHours",
    //   label: "Hours in Use",
    //   sortable: true,
    //   width:"20%"
    // },
    {
      key: "unitConsumption",
      label: " Units Consumed (KWH)",
      sortable: true,
      truncate: true,
      width: "12%",
    },
    // { key: "unit", label: "Vendor Name", sortable: true },
  ], showFacilityColumn);

  const inputData = [
    {
      fieldName: "consumptionPeriod",
      title: "Consumption Month",
      required: true,
      type: "date",
    },

    {
      fieldName: "equipment",
      title: "Equipment",
      placeholder: "Tap to Select",
      type: "select",
      url: `${api}/master/Electricity/getEquipment`,
      field: "equipment",
      required: true,
    },
    {
      fieldName: "brand",
      title: "Brand",
      placeholder: "Autofilled",
      type: "text",
    },
    {
      fieldName: "model",
      title: "Model",
      placeholder: "Autofilled",
      type: "text",
    },
    {
      fieldName: "usedHours",
      title: "Hours in use",
      placeholder: " Enter Hours",
      type: "number",
    },
    {
      fieldName: "unitConsumption",
      title: " Units Consumed",
      placeholder: "Autofilled",
      type: "number",
    },
    // {
    //   fieldName: "reasonForDeviation",
    //   title: "Reason For Deviation",
    //   placeholder: "reason for any deviation in meter reading",
    //   type: "text",
    // },
    // {
    //   fieldName: "calorificValue.unit",
    // //   title: "Calorific Value Unit",
    //   placeholder: "Select unit",
    //   type: "select",
    //   options: ["MJ/kg", "MJ/m3"],
    //   required: true,
    // },
    {
      fieldName: "remarks",
      title: "Remark (optional)",
      placeholder: "Additional remarks",
      type: "text",
    },
    {
      fieldName: "editRemarkReason",
      title: "Edit Remark Reason",
      placeholder: "Additional edit remarks",
      type: "text",
      condition: true,
    },
    {
      fieldName: "documents",
      title: "Upload Documents (optional)",
      type: "file",
    },
  ];

  const filters = [
    "Date",
    "Consumption Month",
    "Equipment",
    "Units Consumed (KWH)",
  ];

  // Function to render the selected filter component based on user's choice

  const handleFilterChangeCards = (cardTitle, filterValue, type) => {
    // console.log("first234");
    if (type === "date") {
      const [year, month] = filterValue.split("-");
      setFilters((prev) => ({
        ...prev,
        month,
        year,
      }));
      fetchCardData(year, month, "");
    } else if (type === "option") {
      setFilters((prev) => ({
        ...prev,
        [cardTitle]: filterValue,
      }));
      fetchCardData(filterValue);
    } else {
      setFilters((prev) => ({
        ...prev,
        [cardTitle]: filterValue,
      }));
    }
  };

  const fetchCardData = async (equipment) => {
    try {
      const response = await get(`/scope2/ConsumptionByEquipment/cardData`, {
        params: {
          equipment: equipment,
        },
      });
      if (response) {
        setCardData({
          ...cardData,
          avgUsageHours:
            response.data.data.avgUsageHours.length > 0 &&
            response.data.data.avgUsageHours.map((item) => item.avgUsageHours),
          topEquipment: response.data.data.topEquipment?.equipment,
          totalSum: response.data.data.totalSum,
          FieldName: equipment,
        });
      }
    } catch (error) {
      console.error("Error fetching card data:", error);
    }
  };

  // useEffect(() => {
  //   fetchCardData(selectedEquipment);
  // }, [selectedEquipment]);

  useEffect(() => {
    if (filterValues.length > 0) {
      fetchCardData(filterValues[0]);
    } else if (selectedEquipment) {
      fetchCardData(selectedEquipment);
    }
  }, [filterValues, selectedEquipment]);

  const FetchSequenceData = async () => {
    await get(`/scope2/ConsumptionByEquipment/filter`)
      .then((response) => {
        setFilterValue(
          response.data.data.equipment.map(
            (item) => item?.equipmentDetails?.equipment
          )
        );
        setSelectedEquipment(
          response.data.data.equipment[0]?.equipmentDetails?.equipment
        );
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    FetchSequenceData();
  }, []);

  const renderSelectedFilter = () => {
    switch (selectedFilter) {
      case "Date":
        return (
          <DateRangePickerComponent
            startDate={tempFilter?.startDate}
            endDate={tempFilter?.endDate}
            setStartDate={(date) =>
              setTempFilter((prev) => ({ ...prev, startDate: date }))
            }
            setEndDate={(date) =>
              setTempFilter((prev) => ({ ...prev, endDate: date }))
            }
            setErrors={setErrors}
            errors={errors.Date}
          />
        );
      case "Consumption Month":
        return (
          <MonthYearFilter
            title={"Consumption Month"}
            startMonth={tempFilter?.startMonth}
            endMonth={tempFilter?.endMonth}
            setStartMonth={(date) =>
              setTempFilter((prev) => ({ ...prev, startMonth: date }))
            }
            setEndMonth={(date) =>
              setTempFilter((prev) => ({ ...prev, endMonth: date }))
            }
            setErrors={setErrors}
            errors={errors.Date}
          />
        );
      case "Equipment":
        return (
          <MultiSelect
            title="Equipment"
            selectedFields={tempFilter}
            setSelectedFields={(updater) => {
              setTempFilter((prev) => {
                const newValue =
                  typeof updater === "function" ? updater(prev) : updater;
                return {
                  ...prev,
                  equipment: newValue.equipment || newValue,
                };
              });
            }}
            errors={errors["Equipment"]}
            setErrors={setErrors}
            field="equipment"
            data={uniqueValues.equipment}
          />
        );

      case "Units Consumed (KWH)":
        return (
          <Range
            title="Units Consumed (KWH)"
            selectedRange={tempFilter.unitConsumption}
            setSelectedRange={(range) =>
              setTempFilter((prev) => ({
                ...prev,
                unitConsumption: range,
              }))
            }
            errors={errors["Units Consumed (KWH)"]}
            setErrors={setErrors}
            placeholderMax="Max(Units)"
            placeholderMin="Min(Units)"
          />
        );
      default:
        return null;
    }
  };

  const fetchUniqueValues = async () => {
    try {
      const response = await get(
        `/scope2/ConsumptionByEquipment/getAllConsumptionByEquipment`
      );
      const data = response.data.data;
      console.log(data);

      const uniqueEquipmentType = [
        ...new Set(
          data.map((el) => el.equipment?.equipment).filter(Boolean) // Filter out undefined values
        ),
      ];

      const uniqueUnit = [
        ...new Set(
          data.map((el) => el?.unitOfElectricityConsumption).filter(Boolean) // Filter out undefined values
        ),
      ];

      return {
        equipment: uniqueEquipmentType,
      };
    } catch (error) {
      console.error("Error fetching unique values:", error);
      return {};
    }
  };

  const handleMenuClick = (event, data) => {
    setAnchorEl(event.currentTarget);
    // setSelectedPetroleum(petroleum);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    // setSelectedPetroleum(null);
  };

  const handleEdit = (data) => {
    handleMenuClose();
    setAddData(true);
    setView(false);
    setdataView(data?._id !== undefined ? data : data?.data);
  };

  const handleView = (data) => {
    handleMenuClose();
    setView(true);
    setAddData(false);
    setdataForView(data?.data);
  };

  const handleDelete = (index) => {
    handleMenuClose();
    setDeleteDialog(true);
    setView(false);
    setdataView(index.id);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // fetching petroleum data
  const fetchData = async (
    filters = isFiltersApplied ? filtersToApply : {}
  ) => {
    try {
      const queryParams = new URLSearchParams({
        ...filters,
        page, // Add the current page
        limit: rowsPerPage, // Add the number of rows per page
        sortField: sortConfig.key, // Sort configuration
        sortOrder: sortConfig.direction,
        company: companyId,
        createdBy: companyId,
      }).toString();
      const response = await get(
        `/scope2/ConsumptionByEquipment/getAllConsumptionByEquipment?${queryParams}`
      );
      let arr = response?.data?.data?.map((item) => {
        return {
          createdAt: new Date(item.createdAt).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          }),
          consumptionPeriod:
            new Date(
              item.consumptionPeriod.year, // Pass the year
              item.consumptionPeriod.month - 1
            ).toLocaleDateString("en-GB", {
              month: "short",
            }) +
            " " +
            item.consumptionPeriod.year,
          unitConsumption: item?.unitConsumption,
          model: item.model,
          equipment: item.equipment?.equipment,
          brand: item.brand,
          action: "View",
          id: item?._id,
          data: item,
        };
      });
      setTableData(arr);
      // fetchCardData();
      FetchSequenceData();
      setPetroleums(response.data.data);
      setTotalPages(response.data.totalPages);
      const uniqueValues = await fetchUniqueValues();
      setUniqueValues(uniqueValues);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  useEffect(() => {
    fetchData(filtersToApply);
    // fetchData()
  }, [page, rowsPerPage, sortConfig]);

  const filtersToApply = {
    startDate: tempFilter?.startDate
      ? tempFilter?.startDate.format("YYYY-MM-DD")
      : "",
    endDate: tempFilter?.endDate
      ? tempFilter?.endDate.format("YYYY-MM-DD")
      : "",
    startMonth: tempFilter?.startMonth
      ? tempFilter?.startMonth.format("YYYY-MM-DD")
      : "",
    endMonth: tempFilter?.endMonth
      ? tempFilter?.endMonth.format("YYYY-MM-DD")
      : "",
    equipment: tempFilter?.equipment.join(","),
    ...(tempFilter.unitConsumption.min
      ? { minUnits: tempFilter.unitConsumption.min }
      : {}),
    ...(tempFilter.unitConsumption.max
      ? { maxUnits: tempFilter.unitConsumption.max }
      : {}),
  };

  // function to validate filters
  const validateFilters = () => {
    let isValid = true;
    const newErrors = {
      Date: false,
      "Units Consumed (KWH)": false,
      Equipment: false,
    };

    if (selectedFilter === "Date") {
      const today = new Date(); // Get the current date
      if (startDate && startDate > today) {
        newErrors.Date = "Start date cannot be in the future";
        isValid = false;
      }

      if (endDate && endDate > today) {
        newErrors.Date = "End date cannot be in the future";
        isValid = false;
      }

      // Ensure that the startDate is less than or equal to the endDate
      if (startDate && endDate && startDate > endDate) {
        newErrors.Date = "End date must be greater than Start date";
        isValid = false;
      }
    }

    // if (
    //   selectedFilter === "Equipment" &&
    //   selectedFields.equipment.length === 0
    // ) {
    //   newErrors["Equipment"] = "Please select atleast one Equipment";
    //   isValid = false;
    // }
    if (selectedFilter === "Units Consumed (KWH)") {
      const min = parseFloat(unitConsumption.min);
      const max = parseFloat(unitConsumption.max);

      if (min < 0 || max < 0) {
        newErrors["Units Consumed (KWH)"] =
          "Min or Max values cannot be negative";
        isValid = false;
      }
      if (!isNaN(min) && !isNaN(max)) {
        if (min > max) {
          newErrors["Units Consumed (KWH)"] =
            "Minimum value cannot exceed maximum";
          isValid = false;
        }
      }
    }

    if (selectedFilter === "Hours Used") {
      const min = parseFloat(hoursRange.min);
      const max = parseFloat(hoursRange.max);

      if (!min && !max) {
        newErrors["Hours Used"] = "Please provide both min and max values";
        isValid = false;
      }

      if (min && isNaN(min)) {
        newErrors["Hours Used"] = "Min hours must be a valid number";
        isValid = false;
      }

      if (max && isNaN(max)) {
        newErrors["Hours Used"] = "Max hours must be a valid number";
        isValid = false;
      }

      if (!isNaN(min) && !isNaN(max) && min > max) {
        newErrors["Hours Used"] =
          "Min hours cannot be greater than max consumption";
        isValid = false;
      }
    }

    setErrors(newErrors);
    return isValid;
  };

  // Applying selected filters
  const handleApplyFilters = () => {
    if (!validateFilters()) return;

    // Reset to first page when applying filters
    setStartDate(tempFilter.startDate);
    setEndDate(tempFilter.endDate);
    setStartMonth(tempFilter.startMonth);
    setEndMonth(tempFilter.endMonth);
    setSelectedFields({
      equipment: tempFilter.equipment,
    });
    setUnitOfConsumption(tempFilter.unitConsumption);
    setPage(1);
    fetchData(filtersToApply);
    setDrawerFilterOpen(false);
    handleAppliedFilters();
  };

  const handleResetFilters = async () => {
    setTempFilter({
      startDate: null,
      endDate: null,
      endMonth: null,
      startMonth: null,
      equipment: [],
      unitConsumption: { min: "", max: "" },
    });

    setStartDate(null);
    setEndDate(null);
    setStartMonth(null);
    setEndMonth(null);
    setSelectedFields({
      equipment: [],
    });
    setUnitOfConsumption({ min: "", max: "" });

    await fetchData({});
    setErrors({});
    setAppliedFilters({});
    setIsFiltersApplied(false);
    setDrawerFilterOpen(false);
  };

  const handleAppliedFilters = () => {
    const isDateApplied = tempFilter?.startDate || tempFilter?.endDate;
    const isConsumptionMonth = tempFilter?.startMonth || tempFilter?.endMonth;
    const isEquipmentTypeApplied = selectedFields.vendor?.length > 0;
    // const isEquipmentApplied = selectedFields.equipment?.length > 0;
    const isEquipmentApplied = tempFilter?.equipment?.length > 0;

    const isUnitRangeApplied =
      tempFilter.unitConsumption.min || tempFilter.unitConsumption.max;

    setIsFiltersApplied(
      isDateApplied ||
        isConsumptionMonth ||
        isEquipmentTypeApplied ||
        isUnitRangeApplied ||
        isEquipmentApplied
    );

    setAppliedFilters((prevAppliedFilters) => ({
      ...prevAppliedFilters,
      Date: isDateApplied,
      "Consumption Month": isConsumptionMonth,
      Equipment: isEquipmentApplied,
      "Units Consumed (KWH)": isUnitRangeApplied,
    }));
  };

  // Handle Sorting function
  const handleSort = (column, direction) => {
    setSortConfig({ key: column, direction });
  };

  const StyledPaginationItem = styled(PaginationItem)(({ theme }) => ({
    "&.Mui-selected": {
      backgroundColor: "green",
      color: "#fff",
      fontWeight: "bold",
    },
    "&:hover": {
      backgroundColor: "#ededed",
    },
  }));

  const handleFilterDrawer = () => {
    setTempFilter({
      startDate: startDate,
      endDate: endDate,
      startMonth: startMonth,
      endMonth: endMonth,
      equipment: selectedFields.equipment,
      unitConsumption: {
        min: unitConsumption.min,
        max: unitConsumption.max,
      },
    });
    setDrawerFilterOpen(false);
    // setErrors({ Date: false, Role: false });
  };

  const handleOpenFilterDrawer = () => {
    setTempFilter({
      startDate: startDate,
      endDate: endDate,
      startMonth: startMonth,
      endMonth: endMonth,
      equipment: selectedFields.equipment,
      unitConsumption: tempFilter.unitConsumption,
    });
    setDrawerFilterOpen(true);
  };

  return (
    <Box
      sx={{
        backgroundColor: "#ededed",
      }}
    >
      <Snackbar
        open={snackOpen.open}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={() => setsnackOpen({ ...snackOpen, open: false })}
      >
        <Alert
          // onClose={handleClose}
          severity={snackOpen.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackOpen.message}
          {/* Add user Successfully */}
        </Alert>
      </Snackbar>

      <AddConsumptionByEquipment
        addData={addData}
        setAddData={setAddData}
        id={dataView ? dataView._id : ""}
        SelectedData={dataView}
        fetchData={fetchData}
        inputData={inputData}
        addUrl={`${api}/scope2/consumptionByEquipment/addConsumptionByEquipment`}
        updateUrl={`${api}/scope2/consumptionByEquipment/updateConsumptionByEquipment`}
        setsnackOpen={setsnackOpen}
      />
      <ViewConsumptionByEquipment
        view={view}
        setView={setView}
        selectedData={dataforView}
        handleEdit={handleEdit}
        companyAdmin={user?.companyAdmin}
      />

      <Cards
        data={bannerData}
        title={"Electricity"}
        onFilterChange={handleFilterChangeCards}
      />
      {deleteDialog && (
        <DeleteAlertDialog
          {...{
            deleteDialog,
            setDeleteDialog,
            method: "delete",
            id: dataView,
            url: `${api}/scope2/consumptionByEquipment/deleteConsumptionByEquipment`,
            setsnackOpen,
            fetchData,
            fetchCardData,
          }}
          // {...{ deleteDialog, setDeleteDialog, handleDeleteAggree }}
        />
      )}

      <Box>
        {drawerFilterOpen && (
          <FilterDrawer
            {...{
              renderSelectedFilter,
              drawerFilterOpen,
              setDrawerFilterOpen,
              handleApplyFilters,
              handleFilterDrawer,
              setSelectedFilter,
              handleResetFilters,
              selectedFilter,
              filters,
              appliedFilters,
              selectedFields,
              setSelectedFields,
            }}
          />
        )}
        {/* Top Box for Heading, Filter Button, Add Data Button */}
        <TopMenuUpload
          setData={setdataView}
          setAddData={setAddData}
          {...{
            // heading: "Coal",
            setBulkUploadModal,
            // setDrawerFilterOpen,
            setDrawerFilterOpen: handleOpenFilterDrawer,
            filterApplied: isFiltersApplied,
          }}
        />
      </Box>

      <ViewTable
        headers={headers}
        title="Consumption By Equipment"
        data={mapTableDataWithFacility(tableData, showFacilityColumn)}
        onSort={handleSort}
        sortConfig={sortConfig}
        onMenuClick={handleMenuClick}
        editIcon={user?.companyAdmin ? "disable" : "enable"}
        page={2}
        count={10}
        onPageChange={() => {
          console.log("first");
        }}
        onView={handleView}
        onEdit={handleEdit}
        onDelete={handleDelete}
      />
      {totalPages > 1 && (
        <PaginationBox
          {...{ totalPages, page, handleChangePage, StyledPaginationItem }}
        />
      )}

      {/* Menu for Actions */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        PaperProps={{
          sx: {
            width: "120px",
            border: "1px solid #ddd",
            marginLeft: "-47px",
          },
        }}
      >
        <MenuItem onClick={handleView} sx={{ fontSize: "14px" }}>
          <AssignmentIcon sx={{ marginRight: "8px", fontSize: "large" }} /> View
          Logs
        </MenuItem>
        <MenuItem onClick={handleEdit} sx={{ fontSize: "14px" }}>
          <EditIcon sx={{ marginRight: "8px", fontSize: "large" }} /> Edit
        </MenuItem>

        <MenuItem onClick={handleDelete} sx={{ fontSize: "14px" }}>
          <DeleteIcon sx={{ marginRight: "8px", fontSize: "large" }} /> Delete
        </MenuItem>
      </Menu>

      {bulkUploadModal && (
        <BulkUploadModal
          onCloseBulkUpload={handleCloseBulkUpload}
          isBulkUploadModal={bulkUploadModal}
          setsnackOpen={setsnackOpen}
          excelData={excelData}
          formDataBulkUpload={formDataBulkUpload}
          setFormDataBulkUpload={setFormDataBulkUpload}
          setMatchData={setMatchData}
          errorClose={uploadErrorClose}
          setBulkUploadTable={setBulkUploadTable}
          setBulkUploadModal={setBulkUploadModal}
          fileName={"Electricity Equipment"}
          url={"/scope2/consumptionByEquipment/electricity/bulkupload"}
        />
      )}

      {bulkUploadTable && (
        <BulkUpload
          matchData={matchData}
          setMatchData={setMatchData}
          onClose={() => setBulkUploadTable(false)}
          bulkUploadTable={bulkUploadTable}
          formData={formDataBulkUpload}
          setFormData={setFormDataBulkUpload}
          setFormDatas={setFormData}
          formDatas={formData}
          addNew={false}
          title1="Equipment Name"
          keyValue1="equipment"
          EquipmentURl={`/master/Electricity/creatEquipment`}
          options1={equipmentData}
          setEquipmentData={setEquipmentData}
          bulkUploadUrl={"/scope2/consumptionByEquipment/electricity/jsonUpload"}
          setsnackOpen={setsnackOpen}
          jsonBulkUpload={formDataBulkUpload}
          // options1={typeOfSubstanceList}
          matched1={"equipmentMatched"}
          onConfirm={() => {
            setBulkUploadTable(false);
            fetchData();
           
          }}
        />
      )}
    </Box>
  );
};

export default ElectricityConsumption;
